import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { useTheme } from "@mui/styles";
import React, { useMemo, useState } from "react";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { uniqWith as _uniqWith } from "lodash";
import useAppBarHeight from "../hooks/useAppBarHeight";
import { useSessionContext } from "@/contexts/SessionContext";
import { getPresignedReferenceUrl } from "@/services/main";
export default React.memo(function (_a) {
    var _b, _c;
    var references = _a.references, zIndex = _a.zIndex;
    var theme = useTheme();
    var token = useSessionContext().token;
    var appBarHeight = useAppBarHeight();
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var refoOpen = Boolean(anchorEl);
    var id = refoOpen ? 'hw-reference-list' : undefined;
    var _e = useState(null), openFile = _e[0], setOpenFile = _e[1];
    var _f = useState(null), openDocument = _f[0], setOpenDocument = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var refs = useMemo(function () {
        if (references && references.length > 0) {
            var r = references === null || references === void 0 ? void 0 : references.map(function (ref) { return typeof ref === 'string' ? JSON.parse(ref) : ref; });
            return _uniqWith(r, function (a, b) {
                return (a.link === b.link &&
                    a.file_name == b.file_name &&
                    a.page_label === b.page_label &&
                    a.file_path === b.file_path);
            });
        }
        return [];
    }, [references]);
    var handleClick = function (event) {
        if (anchorEl)
            setAnchorEl(null);
        else
            setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handelDocumentLinkClick = function (event, link, title) {
        if (link.indexOf('.html') > -1 || (link === null || link === void 0 ? void 0 : link.indexOf('s3://')) === -1) {
            window.open(link, '_blank');
        }
        else {
            var s3_url = link;
            setLoading(true);
            getPresignedReferenceUrl({ s3_url: s3_url }).then(function (res) {
                var _a;
                setLoading(false);
                var downloadLink = document.createElement('a');
                downloadLink.href = (_a = res.data) === null || _a === void 0 ? void 0 : _a.presigned_url;
                downloadLink.download = title || 'downloaded_file';
                downloadLink.style.display = 'none';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }).catch(function (err) {
                console.log(err);
                setLoading(false);
            });
        }
        event.stopPropagation();
    };
    var handlePDFClick = function (event, file, page, title) {
        getPresignedReferenceUrl({ s3_url: file }).then(function (res) {
            var _a;
            setLoading(false);
            var url = "".concat((_a = res.data) === null || _a === void 0 ? void 0 : _a.presigned_url).concat(page ? "#page=" + page : '');
            window.open(url, '_blank');
        }).catch(function (err) {
            console.log(err);
            setLoading(false);
        });
        if (event)
            event === null || event === void 0 ? void 0 : event.stopPropagation();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsx(IconButton, { onClick: handleClick, children: _jsx(AutoStoriesIcon, { sx: { fontSize: 18, color: (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.text) === null || _c === void 0 ? void 0 : _c.primary } }) }) }), refoOpen &&
                _jsx(List, { sx: { width: '100%', backgroundColor: 'rgba(16, 166, 118, 0.133)', mt: 1, mb: 2, borderRadius: 2 }, children: refs === null || refs === void 0 ? void 0 : refs.map(function (reference, index) {
                        return (_jsx(ListItem, { sx: { cursor: "pointer" }, onClick: function (e) {
                                // console.log(reference)
                                // let fileUrl = reference?.link || reference?.file_path
                                // if(reference?.doc_id && fileUrl?.toLowerCase().indexOf('pdf') === -1) {
                                //     e.stopPropagation()
                                //     setOpenDocument(reference?.doc_id)
                                // } else {
                                // if(fileUrl.toLowerCase().indexOf('pdf') > -1){
                                //     handlePDFClick(e, fileUrl, reference?.page_label, (reference?.title || '').split('.')[0])
                                // } else {
                                //     handelDocumentLinkClick(e, fileUrl, (reference?.title || '').split('.')[0]) 
                                // }
                                // }
                            }, children: _jsx(ListItemText, { secondary: _jsx(React.Fragment, { children: "".concat((reference === null || reference === void 0 ? void 0 : reference.link) || (reference === null || reference === void 0 ? void 0 : reference.title) || (reference === null || reference === void 0 ? void 0 : reference.file_name), " ").concat(reference.page_label && reference.page_label !== '' ? "(Page:" + reference.page_label + ")" : '') }) }) }));
                    }) })] }));
});
